import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  
  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  // If not authenticated, redirect to login (handled by useAuth)
  if (!isAuthenticated) {
    const currentHash = `#${location.pathname}${location.search}`;
    try {
      sessionStorage.setItem('redirectAfterLogin', currentHash);
    } catch {
      // ignore
    }

    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};
